export const orderedMenu = [ {
    "id" : 2300,
    "type" : "MEAL",
    "title" : "Cheese Sandwich",
    "start" : new Date(2020, 6, 1),
    "end" : new Date(2020, 6, 1),
    "desc" : null,
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2301,
    "type" : "MEAL",
    "title" : "Ham & Cheddar Wrap",
    "start" : new Date(2020, 6, 1),
    "end" : new Date(2020, 6, 1),
    "desc" : null,
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2302,
    "type" : "MEAL",
    "title" : "Chicken Salad",
    "start" : new Date(2020, 6, 1),
    "end" : new Date(2020, 6, 1),
    "desc" : "Chicken Salad with Ranch",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2303,
    "type" : "SIDE",
    "title" : "Carrots",
    "start" : new Date(2020, 6, 1),
    "end" : new Date(2020, 6, 1),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2304,
    "type" : "MEAL",
    "title" : "Cheese Pizza",
    "start" : new Date(2020, 6, 2),
    "end" : new Date(2020, 6, 2),
    "desc" : "Veg Pizza",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2305,
    "type" : "MEAL",
    "title" : "Chicken Nuggets",
    "start" : new Date(2020, 6, 2),
    "end" : new Date(2020, 6, 2),
    "desc" : null,
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2306,
    "type" : "MEAL",
    "title" : "Cheese Sandwich",
    "start" : new Date(2020, 6, 2),
    "end" : new Date(2020, 6, 2),
    "desc" : null,
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2307,
    "type" : "SIDE",
    "title" : "Milk & Celery Sticks",
    "start" : new Date(2020, 6, 2),
    "end" : new Date(2020, 6, 2),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2308,
    "type" : "MEAL",
    "title" : "Pepperoni Pizza",
    "start" : new Date(2020, 6, 3),
    "end" : new Date(2020, 6, 3),
    "desc" : null,
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2309,
    "type" : "MEAL",
    "title" : "BBQ Chicken Sandwich w/Bun",
    "start" : new Date(2020, 6, 3),
    "end" : new Date(2020, 6, 3),
    "desc" : "Chicken, Sweet Sause",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2310,
    "type" : "SIDE",
    "title" : "Fresh Fruits",
    "start" : new Date(2020, 6, 3),
    "end" : new Date(2020, 6, 3),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2311,
    "type" : "HOLIDAY",
    "title" : "***No School***",
    "start" : new Date(2020, 6, 4),
    "end" : new Date(2020, 6, 4),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : null
  }, {
    "id" : 2312,
    "type" : "HOLIDAY",
    "title" : "***No School***",
    "start" : new Date(2020, 6, 5),
    "end" : new Date(2020, 6, 5),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : null
  }, {
    "id" : 2313,
    "type" : "MEAL",
    "title" : "Pepperoni Pizza",
    "start" : new Date(2020, 6, 6),
    "end" : new Date(2020, 6, 6),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2314,
    "type" : "MEAL",
    "title" : "BBQ Chicken Sandwich w/Bun",
    "start" : new Date(2020, 6, 6),
    "end" : new Date(2020, 6, 6),
    "desc" : "Chicken, Sweet Sause",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2315,
    "type" : "SIDE",
    "title" : "Fresh Fruits",
    "start" : new Date(2020, 6, 6),
    "end" : new Date(2020, 6, 6),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2316,
    "type" : "MEAL",
    "title" : "Cheese Pizza",
    "start" : new Date(2020, 6, 7),
    "end" : new Date(2020, 6, 7),
    "desc" : "Veg Pizza",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2317,
    "type" : "MEAL",
    "title" : "Chicken Nuggets",
    "start" : new Date(2020, 6, 7),
    "end" : new Date(2020, 6, 7),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2318,
    "type" : "MEAL",
    "title" : "Cheese Sandwich",
    "start" : new Date(2020, 6, 7),
    "end" : new Date(2020, 6, 7),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2319,
    "type" : "SIDE",
    "title" : "Milk & Celery Sticks",
    "start" : new Date(2020, 6, 7),
    "end" : new Date(2020, 6, 7),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2320,
    "type" : "MEAL",
    "title" : "French Sticks",
    "start" : new Date(2020, 6, 8),
    "end" : new Date(2020, 6, 8),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2321,
    "type" : "MEAL",
    "title" : "Ham & Cheddar Wrap",
    "start" : new Date(2020, 6, 8),
    "end" : new Date(2020, 6, 8),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2322,
    "type" : "MEAL",
    "title" : "Chicken Salad",
    "start" : new Date(2020, 6, 8),
    "end" : new Date(2020, 6, 8),
    "desc" : "Chicken Salad with Ranch",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2323,
    "type" : "SIDE",
    "title" : "Carrots",
    "start" : new Date(2020, 6, 8),
    "end" : new Date(2020, 6, 8),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2324,
    "type" : "MEAL",
    "title" : "Cheese Sandwich",
    "start" : new Date(2020, 6, 9),
    "end" : new Date(2020, 6, 9),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2325,
    "type" : "MEAL",
    "title" : "Veg Salad",
    "start" : new Date(2020, 6, 9),
    "end" : new Date(2020, 6, 9),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2326,
    "type" : "MEAL",
    "title" : "Chicken Salad",
    "start" : new Date(2020, 6, 9),
    "end" : new Date(2020, 6, 9),
    "desc" : "Chicken Salad with Ranch",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2327,
    "type" : "SIDE",
    "title" : "Carrots",
    "start" : new Date(2020, 6, 9),
    "end" : new Date(2020, 6, 9),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2328,
    "type" : "MEAL",
    "title" : "Cheese Pizza",
    "start" : new Date(2020, 6, 10),
    "end" : new Date(2020, 6, 10),
    "desc" : "Veg Pizza",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2329,
    "type" : "MEAL",
    "title" : "Chicken Nuggets",
    "start" : new Date(2020, 6, 10),
    "end" : new Date(2020, 6, 10),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2330,
    "type" : "MEAL",
    "title" : "Cheese Sandwich",
    "start" : new Date(2020, 6, 10),
    "end" : new Date(2020, 6, 10),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2331,
    "type" : "SIDE",
    "title" : "Milk & Celery Sticks",
    "start" : new Date(2020, 6, 10),
    "end" : new Date(2020, 6, 10),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2332,
    "type" : "HOLIDAY",
    "title" : "***No School***",
    "start" : new Date(2020, 6, 11),
    "end" : new Date(2020, 6, 11),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : null
  }, {
    "id" : 2333,
    "type" : "HOLIDAY",
    "title" : "***No School***",
    "start" : new Date(2020, 6, 12),
    "end" : new Date(2020, 6, 12),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : null
  }, {
    "id" : 2334,
    "type" : "MEAL",
    "title" : "Pepperoni Pizza",
    "start" : new Date(2020, 6, 13),
    "end" : new Date(2020, 6, 13),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2335,
    "type" : "MEAL",
    "title" : "BBQ Chicken Sandwich w/Bun",
    "start" : new Date(2020, 6, 13),
    "end" : new Date(2020, 6, 13),
    "desc" : "Chicken, Sweet Sause",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2336,
    "type" : "SIDE",
    "title" : "Fresh Fruits",
    "start" : new Date(2020, 6, 13),
    "end" : new Date(2020, 6, 13),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2337,
    "type" : "MEAL",
    "title" : "Cheese Pizza",
    "start" : new Date(2020, 6, 14),
    "end" : new Date(2020, 6, 14),
    "desc" : "Veg Pizza",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2338,
    "type" : "MEAL",
    "title" : "Chicken Nuggets",
    "start" : new Date(2020, 6, 14),
    "end" : new Date(2020, 6, 14),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2339,
    "type" : "MEAL",
    "title" : "Cheese Sandwich",
    "start" : new Date(2020, 6, 14),
    "end" : new Date(2020, 6, 14),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2340,
    "type" : "SIDE",
    "title" : "Milk & Celery Sticks",
    "start" : new Date(2020, 6, 14),
    "end" : new Date(2020, 6, 14),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2341,
    "type" : "MEAL",
    "title" : "French Sticks",
    "start" : new Date(2020, 6, 15),
    "end" : new Date(2020, 6, 15),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2342,
    "type" : "MEAL",
    "title" : "Ham & Cheddar Wrap",
    "start" : new Date(2020, 6, 15),
    "end" : new Date(2020, 6, 15),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2343,
    "type" : "MEAL",
    "title" : "Chicken Salad",
    "start" : new Date(2020, 6, 15),
    "end" : new Date(2020, 6, 15),
    "desc" : "Chicken Salad with Ranch",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2344,
    "type" : "SIDE",
    "title" : "Carrots",
    "start" : new Date(2020, 6, 15),
    "end" : new Date(2020, 6, 15),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2345,
    "type" : "MEAL",
    "title" : "Cheese Sandwich",
    "start" : new Date(2020, 6, 16),
    "end" : new Date(2020, 6, 16),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2346,
    "type" : "MEAL",
    "title" : "Veg Salad",
    "start" : new Date(2020, 6, 16),
    "end" : new Date(2020, 6, 16),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2347,
    "type" : "MEAL",
    "title" : "Chicken Salad",
    "start" : new Date(2020, 6, 16),
    "end" : new Date(2020, 6, 16),
    "desc" : "Chicken Salad with Ranch",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2348,
    "type" : "SIDE",
    "title" : "Carrots",
    "start" : new Date(2020, 6, 16),
    "end" : new Date(2020, 6, 16),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2349,
    "type" : "MEAL",
    "title" : "Cheese Pizza",
    "start" : new Date(2020, 6, 17),
    "end" : new Date(2020, 6, 17),
    "desc" : "Veg Pizza",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2350,
    "type" : "MEAL",
    "title" : "Chicken Nuggets",
    "start" : new Date(2020, 6, 17),
    "end" : new Date(2020, 6, 17),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2351,
    "type" : "MEAL",
    "title" : "Cheese Sandwich",
    "start" : new Date(2020, 6, 17),
    "end" : new Date(2020, 6, 17),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2352,
    "type" : "SIDE",
    "title" : "Milk & Celery Sticks",
    "start" : new Date(2020, 6, 17),
    "end" : new Date(2020, 6, 17),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2353,
    "type" : "HOLIDAY",
    "title" : "***No School***",
    "start" : new Date(2020, 6, 18),
    "end" : new Date(2020, 6, 18),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : null
  }, {
    "id" : 2354,
    "type" : "HOLIDAY",
    "title" : "***No School***",
    "start" : new Date(2020, 6, 19),
    "end" : new Date(2020, 6, 19),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : null
  }, {
    "id" : 2355,
    "type" : "MEAL",
    "title" : "Pepperoni Pizza",
    "start" : new Date(2020, 6, 20),
    "end" : new Date(2020, 6, 20),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2356,
    "type" : "MEAL",
    "title" : "BBQ Chicken Sandwich w/Bun",
    "start" : new Date(2020, 6, 20),
    "end" : new Date(2020, 6, 20),
    "desc" : "Chicken, Sweet Sause",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2357,
    "type" : "SIDE",
    "title" : "Fresh Fruits",
    "start" : new Date(2020, 6, 20),
    "end" : new Date(2020, 6, 20),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2358,
    "type" : "MEAL",
    "title" : "Cheese Pizza",
    "start" : new Date(2020, 6, 21),
    "end" : new Date(2020, 6, 21),
    "desc" : "Veg Pizza",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2359,
    "type" : "MEAL",
    "title" : "Chicken Nuggets",
    "start" : new Date(2020, 6, 21),
    "end" : new Date(2020, 6, 21),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2360,
    "type" : "MEAL",
    "title" : "Cheese Sandwich",
    "start" : new Date(2020, 6, 21),
    "end" : new Date(2020, 6, 21),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2361,
    "type" : "SIDE",
    "title" : "Milk & Celery Sticks",
    "start" : new Date(2020, 6, 21),
    "end" : new Date(2020, 6, 21),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2362,
    "type" : "MEAL",
    "title" : "French Sticks",
    "start" : new Date(2020, 6, 22),
    "end" : new Date(2020, 6, 22),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2363,
    "type" : "MEAL",
    "title" : "Ham & Cheddar Wrap",
    "start" : new Date(2020, 6, 22),
    "end" : new Date(2020, 6, 22),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2364,
    "type" : "MEAL",
    "title" : "Chicken Salad",
    "start" : new Date(2020, 6, 22),
    "end" : new Date(2020, 6, 22),
    "desc" : "Chicken Salad with Ranch",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2365,
    "type" : "SIDE",
    "title" : "Carrots",
    "start" : new Date(2020, 6, 22),
    "end" : new Date(2020, 6, 22),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2366,
    "type" : "MEAL",
    "title" : "Cheese Sandwich",
    "start" : new Date(2020, 6, 23),
    "end" : new Date(2020, 6, 23),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2367,
    "type" : "MEAL",
    "title" : "Veg Salad",
    "start" : new Date(2020, 6, 23),
    "end" : new Date(2020, 6, 23),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2368,
    "type" : "MEAL",
    "title" : "Chicken Salad",
    "start" : new Date(2020, 6, 23),
    "end" : new Date(2020, 6, 23),
    "desc" : "Chicken Salad with Ranch",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2369,
    "type" : "SIDE",
    "title" : "Carrots",
    "start" : new Date(2020, 6, 23),
    "end" : new Date(2020, 6, 23),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2370,
    "type" : "MEAL",
    "title" : "Cheese Pizza",
    "start" : new Date(2020, 6, 24),
    "end" : new Date(2020, 6, 24),
    "desc" : "Veg Pizza",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2371,
    "type" : "MEAL",
    "title" : "Chicken Nuggets",
    "start" : new Date(2020, 6, 24),
    "end" : new Date(2020, 6, 24),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2372,
    "type" : "MEAL",
    "title" : "Cheese Sandwich",
    "start" : new Date(2020, 6, 24),
    "end" : new Date(2020, 6, 24),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2373,
    "type" : "SIDE",
    "title" : "Milk & Celery Sticks",
    "start" : new Date(2020, 6, 24),
    "end" : new Date(2020, 6, 24),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2374,
    "type" : "HOLIDAY",
    "title" : "***No School***",
    "start" : new Date(2020, 6, 25),
    "end" : new Date(2020, 6, 25),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : null
  }, {
    "id" : 2375,
    "type" : "HOLIDAY",
    "title" : "***No School***",
    "start" : new Date(2020, 6, 26),
    "end" : new Date(2020, 6, 26),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : null
  }, {
    "id" : 2376,
    "type" : "MEAL",
    "title" : "Pepperoni Pizza",
    "start" : new Date(2020, 6, 27),
    "end" : new Date(2020, 6, 27),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2377,
    "type" : "MEAL",
    "title" : "BBQ Chicken Sandwich w/Bun",
    "start" : new Date(2020, 6, 27),
    "end" : new Date(2020, 6, 27),
    "desc" : "Chicken, Sweet Sause",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2378,
    "type" : "SIDE",
    "title" : "Fresh Fruits",
    "start" : new Date(2020, 6, 27),
    "end" : new Date(2020, 6, 27),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2379,
    "type" : "MEAL",
    "title" : "Cheese Pizza",
    "start" : new Date(2020, 6, 28),
    "end" : new Date(2020, 6, 28),
    "desc" : "Veg Pizza",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2380,
    "type" : "MEAL",
    "title" : "Chicken Nuggets",
    "start" : new Date(2020, 6, 28),
    "end" : new Date(2020, 6, 28),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2381,
    "type" : "MEAL",
    "title" : "Cheese Sandwich",
    "start" : new Date(2020, 6, 28),
    "end" : new Date(2020, 6, 28),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2382,
    "type" : "SIDE",
    "title" : "Milk & Celery Sticks",
    "start" : new Date(2020, 6, 28),
    "end" : new Date(2020, 6, 28),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2383,
    "type" : "MEAL",
    "title" : "Cheese Pizza",
    "start" : new Date(2020, 6, 29),
    "end" : new Date(2020, 6, 29),
    "desc" : "Veg Pizza",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2384,
    "type" : "MEAL",
    "title" : "Chicken Nuggets",
    "start" : new Date(2020, 6, 29),
    "end" : new Date(2020, 6, 29),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2385,
    "type" : "MEAL",
    "title" : "Cheese Sandwich",
    "start" : new Date(2020, 6, 29),
    "end" : new Date(2020, 6, 29),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2386,
    "type" : "SIDE",
    "title" : "Milk & Celery Sticks",
    "start" : new Date(2020, 6, 29),
    "end" : new Date(2020, 6, 29),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2387,
    "type" : "MEAL",
    "title" : "French Sticks",
    "start" : new Date(2020, 6, 30),
    "end" : new Date(2020, 6, 30),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2388,
    "type" : "MEAL",
    "title" : "Veg Salad",
    "start" : new Date(2020, 6, 30),
    "end" : new Date(2020, 6, 30),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2389,
    "type" : "MEAL",
    "title" : "Chicken Salad",
    "start" : new Date(2020, 6, 30),
    "end" : new Date(2020, 6, 30),
    "desc" : "Chicken Salad with Ranch",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2390,
    "type" : "SIDE",
    "title" : "Carrots",
    "start" : new Date(2020, 6, 30),
    "end" : new Date(2020, 6, 30),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  }, {
    "id" : 2391,
    "type" : "MEAL",
    "title" : "Cheese Pizza",
    "start" : new Date(2020, 6, 31),
    "end" : new Date(2020, 6, 31),
    "desc" : "Veg Pizza",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2392,
    "type" : "MEAL",
    "title" : "Chicken Nuggets",
    "start" : new Date(2020, 6, 31),
    "end" : new Date(2020, 6, 31),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2393,
    "type" : "MEAL",
    "title" : "Cheese Sandwich",
    "start" : new Date(2020, 6, 31),
    "end" : new Date(2020, 6, 31),
    "desc" : "",
    "price" : 3.0,
    "reducedPrice" : 2.0
  }, {
    "id" : 2394,
    "type" : "SIDE",
    "title" : "Milk & Celery Sticks",
    "start" : new Date(2020, 6, 31),
    "end" : new Date(2020, 6, 31),
    "desc" : null,
    "price" : 0.0,
    "reducedPrice" : 0.0
  } ] ;

export const menuItems = [{itemName: "Name1", itemBody: "Item1 Body"}, {itemName: "Name1", itemBody: "Item1 Body"}, {itemName: "Name1", itemBody: "Item1 Body"}, {itemName: "Name1", itemBody: "Item1 Body"}];


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/AdminReports/mockData/mockData.js